import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { MySessions } from '@/features/sessions/MySessions';

export const Route = createFileRoute('/speaking-sessions')({
  component: SpeakingSessionsPage,
});

function SpeakingSessionsPage() {
  return (
    <div className="grid gap-6">
      <PageHeader
        title="1-on-1 speaking sessions"
        description="A live practice interview with a teacher, with bands and a comment afterwards."
      />
      <MySessions />
    </div>
  );
}
